import {FC} from 'react';
import formatDate from 'date-fns/format';
import {DateFormat} from 'types';

export type DateValueProps = {
    className?: string;
    format: DateFormat;
    value: Date;
};

// https://date-fns.org/v2.28.0/docs/format
const FORMATS: Record<DateFormat, string> = {
    date: 'yyyy-MM-dd',
    datetime: 'yyyy-MM-dd, hh:mm a',
    time: 'p',
};

const DateValue: FC<DateValueProps> = ({className, format, value}) => (
    <div className={className}>{formatDate(value, FORMATS[format])}</div>
);

export default DateValue;
